import React, { Children, PureComponent } from 'react';

import { ToolboxAPI } from '@philips-emr/tws-components-api';
import { Direction } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, element, oneOf, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, enumValues, isEnumValid } from '@philips-emr/tws-utils';

import './toolbox.scss';

const acceptedTypes = [
  ComponentType.DATA_DISPLAY,
  ComponentType.NAVIGATION,
];

@AwesomeComponent({ type: ComponentType.LAYOUT, api: ToolboxAPI })
class Toolbox extends PureComponent {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    direction: oneOf(enumValues(Direction)),
    uuid: string,
  };

  static defaultProps = {
    direction: Direction.HORIZONTAL,
  };

  getClassName() {
    const { direction } = this.props;

    return classNames({
      'c-toolbox': true,
      [`c-toolbox--${direction}`]: isEnumValid(Direction, direction),
    });
  }

  render() {
    const { children, uuid } = this.props;

    const Container = ContainerProvider.provide(this);

    return (
      <Container acceptedTypes={acceptedTypes} className={this.getClassName()} uuid={uuid}>
        <ul className="c-toolbox__actions">
          {Children.map(children, (child, index) => (
            <li className="c-toolbox__action" key={index}>
              {child}
            </li>
          ))}
        </ul>
      </Container>
    );
  }
}

export default Toolbox;
